export const CONTAINER_HEADER_CLASS = "hero-slider-slide";
export const MIN_SLIDE_DELAY_IN_MILLISECONDS = 1000;
